import { aboutData } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-6">
            {aboutData.title}
          </h2>

          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8">
            {aboutData.content}
          </p>

          <div className="flex flex-wrap items-center justify-center gap-3">
            {aboutData.features.map((feat, idx) => (
              <span
                key={idx}
                className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-accent-100/80 text-accent-700 text-sm font-medium"
              >
                <i className="ri-check-double-line text-sm"></i>
                {feat}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}